<template>
  <div class="card-box">
    <slot />
  </div>
</template>

<script>
export default {
  name: "JumbotronComponent",
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/field.scss";

.card-box {
  background-color: $white;
  padding: 10px 15px;
  border-radius: $field-border-radius;
  border: 2px solid #e7ecf2;
  box-shadow: 0 4px 12px #0420400d;
}
</style>
